import { Card } from '@/components/ui/Card'
import { ComingSoonBadge } from '@/components/ui/ComingSoonBadge'
import { cn } from '@/lib/utils'
import { formatDelta, deltaTone } from './formatters'

interface KpiTileProps {
  label: string
  value: string
  delta?: number | null
  hint?: string
  comingSoon?: boolean
  invertDelta?: boolean
  valueClassName?: string
}

export function KpiTile({ label, value, delta, hint, comingSoon, invertDelta, valueClassName }: KpiTileProps) {
  const tone = deltaTone(delta)
  const positiveColour = invertDelta ? 'text-rose-500' : 'text-emerald-500'
  const negativeColour = invertDelta ? 'text-emerald-500' : 'text-rose-500'

  return (
    <Card className={cn('p-4 flex flex-col gap-1.5', comingSoon && 'opacity-60')}>
      <div className="flex items-center justify-between">
        <div className="text-[10px] uppercase tracking-wider text-muted-foreground font-medium">
          {label}
        </div>
        {comingSoon && <ComingSoonBadge />}
      </div>
      <div className={cn('text-2xl font-semibold tabular-nums', !comingSoon && valueClassName)}>
        {comingSoon ? '—' : value}
      </div>
      <div className="text-xs text-muted-foreground min-h-[1rem]">
        {delta != null && !comingSoon && (
          <span
            className={cn(
              'font-medium mr-1',
              tone === 'positive' ? positiveColour : tone === 'negative' ? negativeColour : '',
            )}
          >
            {formatDelta(delta)}
          </span>
        )}
        {hint}
      </div>
    </Card>
  )
}
